var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isAi && !_vm.isBackgroundImage && _vm.showAiHint
    ? _c(
        "span",
        { staticClass: "bk-ai-image" },
        [
          _c(
            "picture",
            {
              ref: "imageElement",
              attrs: {
                "data-iesrc": _vm.defaultImageUrl,
                "data-id": _vm.id,
                "data-image-alt": _vm.cleanImageAlt,
                "data-picture-class": _vm.resolvedPictureClass,
                "data-alt": _vm.resolvedAlt,
                "data-title": _vm.resolvedTitle,
                "data-fetchpriority": _vm.fetchPriority,
                "data-height": _vm.getHeight(),
                "data-width": _vm.getWidth(),
                id: _vm.uuid,
              },
            },
            [
              _vm._t("additionalimages"),
              _vm._v(" "),
              _vm.avifSourceUrl
                ? _c("source", {
                    attrs: { srcset: _vm.avifSourceUrl, type: "image/avif" },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("source", {
                attrs: {
                  srcset: _vm.defaultImageUrl,
                  type: _vm.mimeType(_vm.defaultImageUrl),
                },
              }),
              _vm._v(" "),
              _vm.defaultImageUrl !== _vm.imageUrl
                ? _c("source", {
                    attrs: {
                      srcset: _vm.imageUrl,
                      type: _vm.mimeType(_vm.imageUrl),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.fallbackUrl
                ? _c("source", {
                    attrs: {
                      srcset: _vm.fallbackUrl,
                      type: _vm.mimeType(_vm.fallbackUrl),
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.receivedImageExtension === "tif"
                ? _c("img", {
                    staticClass: "mw-100 h-auto",
                    class: _vm.resolvedPictureClass,
                    attrs: {
                      src: _vm.defaultImageUrl,
                      alt: _vm.resolvedAlt,
                      title: _vm.resolvedTitle,
                      "data-managed-image-classes": _vm.resolvedPictureClass,
                      height: _vm.getHeight(),
                      width: _vm.getWidth(),
                      fetchpriority: _vm.fetchPriority,
                      type: "image/tiff",
                    },
                  })
                : _vm.isImageReady
                ? _c("img", {
                    staticClass: "mw-100 h-auto",
                    class: _vm.resolvedPictureClass,
                    attrs: {
                      alt: _vm.resolvedAlt,
                      title: _vm.resolvedTitle,
                      "data-managed-image-classes": _vm.resolvedPictureClass,
                      height: _vm.getHeight(),
                      width: _vm.getWidth(),
                      fetchpriority: _vm.fetchPriority,
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c("ai-image-hint"),
        ],
        1
      )
    : !_vm.isBackgroundImage
    ? _c(
        "picture",
        {
          ref: "imageElement",
          attrs: {
            "data-iesrc": _vm.defaultImageUrl,
            "data-id": _vm.id,
            "data-image-alt": _vm.cleanImageAlt,
            "data-picture-class": _vm.resolvedPictureClass,
            "data-alt": _vm.resolvedAlt,
            "data-title": _vm.resolvedTitle,
            "data-fetchpriority": _vm.fetchPriority,
            "data-height": _vm.getHeight(),
            "data-width": _vm.getWidth(),
            id: _vm.uuid,
          },
        },
        [
          _vm._t("additionalimages"),
          _vm._v(" "),
          _vm.avifSourceUrl
            ? _c("source", {
                attrs: { srcset: _vm.avifSourceUrl, type: "image/avif" },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("source", {
            attrs: {
              srcset: _vm.defaultImageUrl,
              type: _vm.mimeType(_vm.defaultImageUrl),
            },
          }),
          _vm._v(" "),
          _vm.defaultImageUrl !== _vm.imageUrl
            ? _c("source", {
                attrs: {
                  srcset: _vm.imageUrl,
                  type: _vm.mimeType(_vm.imageUrl),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.fallbackUrl
            ? _c("source", {
                attrs: {
                  srcset: _vm.fallbackUrl,
                  type: _vm.mimeType(_vm.fallbackUrl),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.receivedImageExtension === "tif"
            ? _c("img", {
                staticClass: "mw-100 h-auto",
                class: _vm.resolvedPictureClass,
                attrs: {
                  src: _vm.defaultImageUrl,
                  alt: _vm.resolvedAlt,
                  title: _vm.resolvedTitle,
                  "data-managed-image-classes": _vm.resolvedPictureClass,
                  height: _vm.getHeight(),
                  width: _vm.getWidth(),
                  fetchpriority: _vm.fetchPriority,
                  type: "image/tiff",
                },
              })
            : _vm.isImageReady
            ? _c("img", {
                staticClass: "mw-100 h-auto",
                class: _vm.resolvedPictureClass,
                attrs: {
                  alt: _vm.resolvedAlt,
                  title: _vm.resolvedTitle,
                  "data-managed-image-classes": _vm.resolvedPictureClass,
                  height: _vm.getHeight(),
                  width: _vm.getWidth(),
                  fetchpriority: _vm.fetchPriority,
                },
              })
            : _vm._e(),
        ],
        2
      )
    : _c(
        "div",
        {
          ref: "imageElement",
          class: [_vm.resolvedPictureClass, { "bk-ai-hint-host": _vm.isAi }],
          attrs: {
            "data-background-image": _vm.defaultImageUrl || _vm.fallbackUrl,
          },
        },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm.isAi ? _c("ai-image-hint") : _vm._e(),
        ],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }